export class MonthlyConsumption {
  constructor(
    public consumption: number,
    public messages: number,
  ) { }
}
